import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../lib/useStore.jsx';
import { today } from '../lib/store.js';
import { SKILLS } from '../content/skills.js';
import { suggestedForAge } from '../domain/skills.js';
import { ageAt } from '../domain/age.js';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default function Setup() {
  const { store, addProfile, setPin } = useStore();
  const nav = useNavigate();
  const thisYear = Number(today().slice(0, 4));
  const [name, setName] = useState('');
  const [birthMonth, setBirthMonth] = useState(1);
  const [birthYear, setBirthYear] = useState(thisYear - 8);
  const [wishes, setWishes] = useState(['', '', '']);
  const [pin, setPinLocal] = useState('');
  const first = store.profiles.length === 0;

  const age = ageAt(today(), { birthMonth, birthYear });
  const suggested = suggestedForAge(SKILLS, age).filter((id) => SKILLS.find((s) => s.id === id).safety !== 'adult_enables');

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    if (first && /^\d{4}$/.test(pin)) setPin(pin);
    addProfile({ name: name.trim(), birthMonth, birthYear, enabled: suggested, wishes: wishes.map((w) => w.trim()).filter(Boolean) });
    nav('/');
  };

  return (
    <form className="stack" onSubmit={submit}>
      <h1>{first ? 'Add your first kid' : 'Add someone'}</h1>
      <p className="muted">We'll start their wall with the skills a {age}-year-old usually has a go at. You can change the list any time.</p>

      <div className="field"><label htmlFor="name">Name</label><input id="name" className="input" value={name} onChange={(e) => setName(e.target.value)} autoFocus /></div>
      <div className="row">
        <div className="field" style={{ flex: 1 }}><label htmlFor="bm">Birth month</label>
          <select id="bm" className="input" value={birthMonth} onChange={(e) => setBirthMonth(Number(e.target.value))}>{MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}</select></div>
        <div className="field" style={{ flex: 1 }}><label htmlFor="by">Birth year</label>
          <select id="by" className="input" value={birthYear} onChange={(e) => setBirthYear(Number(e.target.value))}>{Array.from({ length: 18 }, (_, i) => thisYear - 2 - i).map((y) => <option key={y} value={y}>{y}</option>)}</select></div>
      </div>
      <p className="hint">Age is worked out from these, so it stays right. {suggested.length} skills will be on the wall to start.</p>

      <div className="field">
        <label>Three things you wish {name || 'they'} could do without you</label>
        {wishes.map((w, i) => <input key={i} className="input" placeholder={['pack their own bag', 'make their own breakfast', 'do their own laundry'][i]} value={w} onChange={(e) => setWishes(wishes.map((x, j) => (j === i ? e.target.value : x)))} />)}
        <p className="hint">Not required. It helps you notice what matters, and it helps us learn what parents want.</p>
      </div>

      {first && (
        <div className="field"><label htmlFor="pin">Grown-up PIN (4 digits)</label>
          <input id="pin" className="input pin" inputMode="numeric" pattern="\d{4}" maxLength={4} value={pin} onChange={(e) => setPinLocal(e.target.value.replace(/\D/g, ''))} />
          <p className="hint">A speed bump on a shared tablet, not a lock. Leave blank for none.</p></div>
      )}

      <button className="btn primary block" type="submit" disabled={!name.trim()}>Add {name.trim() || 'them'}</button>
    </form>
  );
}
